module.exports = __webpack_public_path__ + "img/logo.58d4bcb5.svg";